import { CatalogService } from './CatalogService';
import {AppEntities, AppServices} from "../../config/entities";

export class VendorCustomerService extends CatalogService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }

    async GetAllCustomers(searchText: string | undefined) {
        console.log("GetAllCustomers");
        let url = AppEntities.VendorCustomer.apiUrl + "/customers";
        if (searchText) {
            url += "?searchText=" + searchText;
        }

        const response = await AppServices.Axios.get(url);
        return response.data;
    }

    async GetAllVendors(searchText: string | undefined) {
        console.log("GetAllVendors");
        let url = AppEntities.VendorCustomer.apiUrl + "/vendors";
        if (searchText) {
            url += "?searchText=" + searchText;
        }

        const response = await AppServices.Axios.get(url);
        return response.data;
    }       
}
// import {AppEntities, AppServices} from "../../config/entities";

// export class VendorCustomerService {
//     async GetAll(searchText: string | undefined) {
//         console.log("GetAll");
//         let url = AppEntities.VendorCustomer.apiUrl;
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }

//     async GetAllCustomers(searchText: string | undefined) {
//         console.log("GetAll");
//         let url = AppEntities.VendorCustomer.apiUrl + "/customers";
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }

//     async GetAllVendors(searchText: string | undefined) {
//         console.log("GetAll");
//         let url = AppEntities.VendorCustomer.apiUrl + "/vendors";
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }    

//     async Get(id: string) {
//         console.log("Get", id);
//         const response = await AppServices.Axios.get(AppEntities.VendorCustomer.apiUrl + "/" + id);
//         return response.data;
//     }

//     async Delete(selectedItemId: string | null) {
//         if (selectedItemId) {
//             console.log("Delete", selectedItemId);
//             const response = await AppServices.Axios.delete(AppEntities.VendorCustomer.apiUrl + "/" + selectedItemId);
//             console.log("Delete response", response);
//         }
//     }

//     async Update(model: any) {
//         console.log("Update", model);
//         const response = await AppServices.Axios.put(AppEntities.VendorCustomer.apiUrl, model);
//         console.log("Update response", response);
//     }

//     async Create(model: any) {
//         console.log("Create", model);
//         const response = await AppServices.Axios.post(AppEntities.VendorCustomer.apiUrl, model);
//         console.log("Create response", response);
//     }
// }